import { useCipher } from '../../../Hooks/Features/Cipher/useCipher'
import { useCommon } from '../../../Hooks/Common/useCommon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Cipher() {

    const { checkPermission } = useCommon();
    const { tagRef, fieldValues, setFieldValues, handleEcryptDecrypt, handleCopy, loader } = useCipher();

    return (
        <div ref={() => checkPermission("Cipher", tagRef)}>
            <div ref={tagRef} id='{"tabname": "cipher", "data": "cipher_tab"}'>
                <h5>Encrypt - Decrypt</h5>
                <div className='mt-2 d-flex gap-4'>
                    <div className='w20 position-relative'>
                        <input title='Secret Key' type={fieldValues?.sk_view} placeholder='Enter Secret Key' className='input-dd w100' value={fieldValues?.secret_key} onChange={(e) => setFieldValues((prev) => ({ ...prev, secret_key: e.target.value }))} />
                        <span className='position-absolute top-0 end-0 mt-2 pt-1 me-1 c-pointer  mr-2' onClick={() => setFieldValues((prev) => ({ ...prev, sk_view: fieldValues?.sk_view === "password" ? "text" : "password" }))} ><FontAwesomeIcon icon={`fa-solid fa-${fieldValues?.sk_view === "password" ? "eye" : "eye-slash"}`} /></span>
                    </div>
                    <div className='w20 position-relative'>
                        <input title='IV' type={fieldValues?.iv_view} placeholder='Enter IV' className='input-dd w100' value={fieldValues?.iv} onChange={(e) => setFieldValues((prev) => ({ ...prev, iv: e.target.value }))} />
                        <span className='position-absolute top-0 end-0 mt-2 pt-1 me-1 c-pointer mr-2' onClick={() => setFieldValues((prev) => ({ ...prev, iv_view: fieldValues?.iv_view === "password" ? "text" : "password" }))} ><FontAwesomeIcon icon={`fa-solid fa-${fieldValues?.iv_view === "password" ? "eye" : "eye-slash"}`} /></span>
                    </div>
                    <div className='d-flex gap-2 align-items-center'>
                        <div>
                            <input type='radio' name='cipher' id='decrypt' checked={fieldValues?.decrypt} onChange={() => setFieldValues((prev) => ({ ...prev, decrypt: true }))} />
                            <label htmlFor='decrypt'>Decrypt</label>
                        </div>
                        <div>
                            <input type='radio' name='cipher' id='encrypt' checked={!fieldValues?.decrypt} onChange={() => setFieldValues((prev) => ({ ...prev, decrypt: false }))} />
                            <label htmlFor='encrypt'>Encrypt</label>
                        </div>
                    </div>
                    {loader ? <button className="button btn-primary" style={{width: "55px"}}>
                        <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                            <span className="sr-only"></span>
                        </div>
                    </button> :
                        <button className='button btn-primary' onClick={handleEcryptDecrypt}>Apply</button>
                    }
                </div>
                <div className='mt-2 d-flex justify-content-between'>
                    <div style={{ width: "49%" }} className='position-relative'>
                        <textarea placeholder={`Enter text to ${fieldValues?.decrypt ? "decrypt" : "encrypt"}...`} className='rounded w100' rows={22} style={{ resize: "none" }} value={fieldValues?.entered_text} onChange={(e) => setFieldValues((prev) => ({ ...prev, entered_text: e.target.value }))} />
                        <div className='d-flex gap-2 bg-white position-absolute top-0 end-0 me-1 mt-1' style={{ color: "#a3a3a3ff" }}>
                            <span className='c-pointer' title='Copy text' onClick={() => handleCopy(true)}>
                                <FontAwesomeIcon icon="fa-solid fa-copy" size='lg' />
                            </span>
                            <span className='c-pointer' title='Reset' onClick={() => setFieldValues((prev) => ({ ...prev, entered_text: "" }))}>
                                <FontAwesomeIcon icon="fa-solid fa-ban" size='lg' />
                            </span>
                        </div>
                    </div>
                    <div style={{ width: "49%" }} className='position-relative'>
                        <textarea className='rounded w100 bg-light' rows={22} style={{ resize: "none" }} value={fieldValues?.generated_text} onChange={(e) => setFieldValues((prev) => ({ ...prev, generated_text: e.target.value }))} disabled={true} />
                        <span className='position-absolute top-0 end-0 me-1 mt-1 c-pointer' title='Copy text' style={{ color: "#a3a3a3ff" }} onClick={() => handleCopy(false)}><FontAwesomeIcon icon="fa-solid fa-copy" size='lg' /></span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Cipher